import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { mergeCmsTexts } from '@/i18n';
import { textCmsService } from '@/services/textCmsService';
import { loadLocaleTexts } from '@/locales';

const useLocalOnly = process.env.REACT_APP_USE_LOCAL_TEXTS === 'true';

export function CmsTextsSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = i18n.language || 'en';

    if (useLocalOnly) {
      loadLocaleTexts(locale).then(data => {
        if (data) mergeCmsTexts(locale, data.texts as Record<string, unknown>);
      });
      return;
    }

    textCmsService
      .getTexts(locale)
      .then(data => {
        const raw = data as unknown as Record<string, unknown>;
        const texts = (raw.texts ?? raw) as Record<string, unknown>;
        mergeCmsTexts(locale, texts);
      })
      .catch(err => {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(
            '[CmsTextsSync] No se pudieron cargar textos del CMS, usando locale local:',
            err?.message || err,
          );
        }
        loadLocaleTexts(locale).then(data => {
          if (data) mergeCmsTexts(locale, data.texts as Record<string, unknown>);
        });
      });
  }, [i18n.language]);

  return null;
}
